import { Component } from '@angular/core';

@Component({
  selector: 'lib-check-mark',
  templateUrl: './check-mark.component.html',
  styleUrl: './check-mark.component.scss'
})
export class LibCheckMarkComponent {


}
